import logo from './logo.svg';
import './App.css';
import Home from './components/Home';
// import ProjectX from './components/ProjectX';

function App() {
  return (
    <div>
      <Home/>
      {/* <ProjectX/> */}
    </div>
  );
}

export default App;
